import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[app-view-host]',
})
export class AppViewDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}